import { render, staticRenderFns } from "./recruitDetail.vue?vue&type=template&id=0f03581c&scoped=true"
import script from "./recruitDetail.vue?vue&type=script&lang=js"
export * from "./recruitDetail.vue?vue&type=script&lang=js"
import style0 from "./recruitDetail.vue?vue&type=style&index=0&id=0f03581c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f03581c",
  null
  
)

export default component.exports